module.exports = __webpack_public_path__ + "static/red-bag1-577fefccf15a8134be889fa7f7601d1a.png";